"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";

import { ForgotPasswordForm } from "@/components/form/forgot-password";
import { getNewPath } from "@/utils/misc";

export const ForgotPassword = ({ email }: { email?: string }) => {
  const router = useRouter();

  const onForgotPasswordSuccess = useCallback(
    (email: string) => {
      router.push(
        getNewPath({
          destination: "/auth/reset-password",
          searchParams: { email },
        }),
      );
    },
    [router],
  );

  return (
    <ForgotPasswordForm
      email={email}
      onForgotPasswordSuccess={onForgotPasswordSuccess}
    />
  );
};
